<template>
  <v-card
    class="gallery-field-image px-3 pt-1 pb-3"
    outlined
    elevation="3"
    :disabled="isDeleting"
  >
    <v-row dense>
      <v-btn icon tile fab x-small class="handle" title="Move" v-if="canMove"
        ><v-icon color="blue">mdi-cursor-move</v-icon></v-btn
      >
      <v-spacer></v-spacer>
      <BtnDeleteConfirmation
        :loading="isDeleting"
        @delete="$emit('delete')"
        tooltip="Delete Image Permanently"
      />
    </v-row>

    <v-img
      aspect-ratio="1"
      :src="img.thumb"
      alt=""
      max-height="250"
      contain
      :class="['grey lighten-1', { handle: canMove }]"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-textarea
      v-if="allowCaption"
      class="my-2"
      :value="img.caption"
      outlined
      rows="2"
      hide-details=""
      @input="$emit('update', { key: 'caption', val: $event })"
      placeholder="Write a Caption"
      dense
    />
    <v-autocomplete
      v-if="allowItemLink"
      @change="$emit('itemSelected', $event)"
      v-model="selectedItemId"
      :items="abcItems"
      item-text="name"
      item-value="id"
      color="teal accent-4"
      placeholder="Select an Item"
      hide-details=""
      filled
      clearable
    ></v-autocomplete>
    <v-checkbox
      v-if="selectedItemId"
      label="Hide Item Name"
      v-model="hideName"
      @change="$emit('update', { key: 'hideName', val: $event })"
    />
    <v-alert
      v-if="deleteError && !isDeleting"
      type="warning"
      dense
      text
      outlined
      >Couldn't delete image. Please try again.</v-alert
    >
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
import _orderBy from 'lodash/orderBy'

import BtnDeleteConfirmation from '@/components/BtnDeleteConfirmation'
export default {
  name: 'ImageFieldCard',
  props: {
    img: {
      type: Object,
      required: true,
      default: () => {},
    },
    canMove: {
      type: Boolean,
      default: true,
    },
    allowCaption: {
      type: Boolean,
      default: false,
    },
    allowItemLink: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BtnDeleteConfirmation,
  },
  data() {
    return {
      isDeleting: false,
      deleteError: false,
      showItemSelect: false,
      selectedItemId: null,
      hideName: false,
    }
  },
  created() {
    this.selectedItemId = this.img.item
    this.hideName = _get(this, 'img.hideName', false)
  },
  methods: {},
  computed: {
    ...mapGetters('itemAndSection', ['getItemById', 'getRealItems']),
    selectedItemName() {
      if (!this.selectedItemId) {
        return false
      }
      let item = this.getItemById(this.selectedItemId)
      return item ? _get(item, 'name') : null
    }, // selectedItemName
    abcItems() {
      return _orderBy(this.getRealItems, 'name')
    }, // abcItems
  },
}
</script>

<style lang="css">
.handle {
  cursor: move;
}
</style>
